import { motion } from 'framer-motion';

const ValuesSection = () => {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Fiabilité',
      description: 'Produits testés et certifiés pour une utilisation professionnelle',
    },
    {
      icon: 'ri-award-line',
      title: 'Qualité médicale',
      description: 'Conformité aux standards internationaux les plus exigeants',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Conformité réglementaire',
      description: 'Respect strict des normes et réglementations en vigueur',
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Partenariat durable',
      description: 'Accompagnement sur le long terme pour nos clients',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-4">
            Nos valeurs
          </h2>
          <p className="text-base md:text-lg text-[#4A4A4A] max-w-3xl mx-auto px-4">
            Des principes qui guident notre engagement envers nos partenaires
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {values.map((value, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-[#E31B23] rounded-full mx-auto mb-4 md:mb-6">
                <i className={`${value.icon} text-white text-2xl sm:text-3xl`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#1A1A1A] mb-2 md:mb-3">
                {value.title}
              </h3>
              <p className="text-sm md:text-base text-[#4A4A4A] leading-relaxed">
                {value.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
